import { Button, Flex, Typography } from 'antd';
import { Content, ModalLayout } from '../../../../../components';

const DeliveryModal = (props) => {
  const { deliveryPrice, setDeliveryPrice, paymentInfo, onPayment } = props;
  const { Text } = Typography;
  return (
    <ModalLayout
      open={deliveryPrice.open}
      onCancel={() =>
        setDeliveryPrice((data) => ({
          ...data,
          open: false,
        }))
      }
      width={400}
      centered
      closable
      title='배송비 안내'
      footer={
        <Button
          type='primary'
          onClick={() => {
            setDeliveryPrice((data) => ({
              ...data,
              open: false,
            }));
            onPayment(deliveryPrice.type, deliveryPrice.paymentMethod);
          }}
        >
          확인
        </Button>
      }
    >
      <Content maxWidth='100%' padding='24px 0 8px'>
        <Flex vertical gap={10}>
          <Text size={15}>
            * 배송비는 할인 및 쿠폰 적용 후 실결제금액을 기준으로 적용됩니다.
          </Text>
          <Text size={15}>
            * 무료배송 기준 금액 미만 결제 시 배송비가 부과됩니다.
          </Text>
        </Flex>
        <div style={{ marginTop: 20 }}>
          {/* <Flex justify='space-between'>
            <Text size={14}>기본 배송비</Text>
            <Text size={14} weight={700}>
              {Number(
                paymentInfo?.total_origin_delivery_price ?? 0,
              ).toLocaleString()}
              원
            </Text>
          </Flex> */}
          <Flex justify='space-between' style={{ marginTop: 8 }}>
            <Text
              size={14}
              style={{
                fontWeight: 600,
              }}
            >
              반영된 배송비
            </Text>
            <Text size={14} weight={700}>
              {Number(paymentInfo?.total_delivery_price ?? 0).toLocaleString()}
              원
            </Text>
          </Flex>
        </div>
      </Content>
    </ModalLayout>
  );
};

export default DeliveryModal;
